import { environmentManager, QueryClient } from "@tanstack/react-query";

function createQueryClient() {
  return new QueryClient();
}

let queryClient: QueryClient | undefined;
export function getQueryClient() {
  if (environmentManager.isServer()) {
    return createQueryClient();
  } else {
    queryClient ??= createQueryClient();
    return queryClient;
  }
}
